module.exports = __webpack_public_path__ + "static/rents-46ac2fe86c8112e2ac2066491f6e2e69.png";